import type { Translations } from "../types";

const tr: Translations = {
  nav: {
    features: "Özellikler",
    pricing: "Fiyatlandırma",
    blog: "Blog",
    freeTools: "Ücretsiz Araçlar",
    contact: "İletişim",
    startFree: "Ücretsiz Başla",
    solutions: "Çözümler",
    useCases: "Kullanım Alanları",
    switchToDark: "Karanlık Moda Geç",
    switchToLight: "Aydınlık Moda Geç",
    solutionsToolsDesc: "Hesaplayıcılar, oluşturucular ve daha fazlası",
    solutionsUseCasesDesc: "Zapify'ı çalışırken görün",
  },
  hero: {
    rotatingWords: ["Otomatik DM", "Yapay Zeka Yanıtları"],
    headline: "Instagram yorumlarına şununla yanıt verin:",
    subheadline:
      "Yorumlara kişiselleştirilmiş DM'lerle otomatik yanıt verin. Potansiyel müşterileri yakalayın ve kitlenizi otopilotta büyütün.",
    cta: "Ücretsiz Başlayın",
    helperText: "Başlamak ücretsiz",
    helperSeparator: "Kolay kurulum",
    trustedBy: "Bize Güvenen",
    creators: "5.000+ içerik üretici",
    dmsSent: "Gönderilen DM",
    dmsCount: "1.000.000+",
  },
  features: {
    headingTitle: "İhtiyacınız Olan Her Şey",
    headingHighlight: "Instagram'ınızı Büyütmek İçin",
    headingDescription:
      "Zapify, saatlerce manuel çalışmadan tasarruf ederken AI asistanınız ve otomasyonunuz üzerinde tam kontrol sağlar.",
    cta: "30 Günlük Ücretsiz Denemeyi Etkinleştir",
    items: [
      {
        title: "DM Otomasyonu",
        description:
          "Her Instagram yorumuna otomatik olarak DM ile yanıt verin. DM kaosunu nitelikli potansiyel müşterilere ve satışlara dönüştürün.",
      },
      {
        title: "Takip İsteği",
        description:
          "Özel içeriğinizi paylaşmadan önce kullanıcıdan sizi takip etmesini istiyoruz.",
      },
      {
        title: "Yapay Zeka Destekli Yanıtlar",
        description:
          "Yorumu anlayan ve sizin gibi konuşan yanıtlar.",
      },
      {
        title: "Tamamen Özelleştirilebilir Ses",
        description:
          "Ton ve stili seçin, kısa/uzun yanıtlar belirleyin ve emoji + #hashtag'leri kontrol edin.",
      },
      {
        title: "Küresel Dil Desteği",
        description: "Onların dilini konuşun, otomatik olarak.",
      },
      {
        title: "E-posta Topla",
        description:
          "Instagram yorumlarından otomatik olarak e-posta listenizi oluşturun.",
      },
      {
        title: "Ekip Erişimi",
        description:
          "Yanıtları, potansiyel müşterileri ve konuşmaları birlikte yönetmek için ekip üyelerini davet edin.",
      },
      {
        title: "Birden Fazla Instagram Hesabı",
        description:
          "Birden fazla Instagram hesabını tek bir panelden bağlayın ve yönetin.",
      },
    ],
  },
  process: {
    headingTitle: "Otomasyona Başlayın",
    headingHighlight: "Dakikalar İçinde",
    headingDescription:
      "DM'lerinizi otomatikleştirmek için bu basit adımları izleyin",
    step: "Adım",
    cta: "Otomasyonu Başlat",
    steps: [
      {
        title: "Tetikleyicileri Seçin",
        description:
          "Hangi gönderilerin ve anahtar kelimelerin otomasyonunuzu etkinleştireceğini seçin.",
      },
      {
        title: "Yanıtı Otomatikleştirin",
        description:
          "Otomatik olarak göndermek için bağlantılar, teklifler veya içerikle kişiselleştirilmiş mesajlar oluşturun.",
      },
      {
        title: "Viral",
        description:
          "Daha fazla oluşturun. Daha az yönetin. Otomasyon gerisini halleder.",
      },
    ],
  },
  engagement: {
    headingTitle: "Instagram Etkileşimini Dönüştürün",
    headingHighlight: "Otopilotta Gelir",
    headingDescription:
      "Her yorumu satış fırsatlarına dönüştürün. Yapay zeka asistanınız konuşmaları yönetirken 7/24 para kazanın",
    card1Title: "Link Tıklamalarını Artırın",
    card1TitleLine2: "Dönüşümler",
    card1Description:
      "Yorumları doğrudan trafiğe dönüştürün. Tekliflerinizi, ürünlerinizi ve içeriklerinizi DM'ler aracılığıyla ilgilenen alıcılara otomatik olarak iletin.",
    card2Title: "7/24 Yapay Zeka Satış Temsilcisi",
    card2Description:
      "Hiçbir yorumu kaçırmayın. Anında yanıt verin ve siz uyurken konuşmaları 7/24 satışa dönüştürün.",
  },
  graph: {
    headingHighlight: "Erişiminizi Katlayın",
    headingHighlightWord: "",
    headingDescription:
      "Otomatik DM'lerin ve yapay zeka yanıtlarının etkileşim oranınızı, takipçi büyümenizi ve satış dönüşümlerinizi 10 kata kadar nasıl artırdığını görün",
    title: "Etkileşimi Artırın",
    by10x: "10 kat",
    subtitle: "Siz uyurken kitlenizi paraya çevirin",
    description:
      "Her yoruma yanıt verin, onları DM'lere dönüştürün ve etkileşimi otomatik olarak artırın.",
    afterZapify: "Zapify Pro Sonrası",
    cta: "Etkileşimi Şimdi Artırın",
  },
  testimonials: {
    headingTitle: "Instagram İçerik Üreticilerinin Neden",
    headingHighlight: "Sevdiğini Görün",
    headingDescription:
      "Instagram etkileşimlerini ve gelirlerini yapay zeka otomasyonuyla dönüştüren influencer ve markalardan gerçek başarı hikayeleri",
    followers: "Takipçi",
  },
  faq: {
    headingTitle: "Sıkça Sorulan",
    headingHighlight: "Sorular",
    headingDescription:
      "Zapify ile başlamak için bilmeniz gereken her şey",
    items: [
      {
        question: "Zapify herhangi bir Instagram hesabıyla çalışır mı?",
        answer:
          "Zapify, Instagram Profesyonel (İş veya İçerik Üretici) hesaplarını destekler. Kişisel hesaplar API tarafından desteklenmez.",
      },
      {
        question: "Zapify mobilde erişilebilir mi?",
        answer:
          "Evet, Zapify mobil tarayıcınızda harika çalışır, Tarayıcı Uygulamasını buradan yükleyebilirsiniz.",
      },
      {
        question: "Otomasyonlar robotik mi duyulacak?",
        answer:
          "Hayır. Zapify, yapay zeka yanıtlarının tarzınıza uyması için marka ses kontrolleri (ton, uzunluk, emoji kullanımı) destekler. Herhangi bir mesajı düzenleyebilir ve insan devri ekleyebilirsiniz.",
      },
      {
        question: "Zapify Meta onaylı mı?",
        answer:
          "Zapify, Meta tarafından Doğrulanmış Teknoloji Sağlayıcısıdır, resmi Instagram Graph API'lerini kullanıyoruz. Hesabınızı güvende tutmak için hız sınırlarına ve politika kurallarına uyuyoruz.",
      },
      {
        question: "Zapify kullanmak güvenli mi?",
        answer:
          "Evet. Tüm kimlik doğrulama Meta'nın güvenli OAuth'unu kullanır. Instagram şifrenizi asla sormayız ve verdiğiniz API izinlerine saygı duyarız.",
      },
      {
        question: "Zapify ücretsiz mi?",
        answer:
          "Yükseltmeden önce otomasyonları test edebilmeniz ve sonuçları görebilmeniz için ücretsiz deneme sunuyoruz.",
      },
      {
        question: "Bir ortak/iş ortağı programınız var mı?",
        answer:
          "Evet. Onaylı ortaklar yeni kayıtlar ve yenilemeler üzerinden komisyon kazanır. Ortak sayfamızdan başvurun.",
      },
      {
        question: "Destek ile nasıl iletişime geçebilirim?",
        answer:
          "Uygulama içi sohbeti kullanın veya bize e-posta gönderin — çoğu soru iş günlerinde aynı gün yanıt alır. Ayrıca kurulum kılavuzları ve en iyi uygulama şablonları sunuyoruz.",
      },
    ],
  },
  verified: {
    headingTitle: "Programlar",
    headingHighlight: "ve Ortaklar",
    headingDescription:
      "Startupımız Stripe for Startups ve Microsoft for Startups 2025 tarafından kabul edildi",
    cta: "Doğrulamayı Görüntüle",
    badge: "Doğrulanmış",
    heading: "Güvenilir Meta doğrulanmış teknoloji sağlayıcınız",
    description: "Şirketimiz Microsoft Startups for Founders ve Stripe Startup Program tarafından resmi olarak kabul edilmiştir.",
    missionNote: "Bakınız: Ana Sayfa → Kahraman ve İçerik Üretici Sorunları bölümleri misyonumuz ve değerlerimiz için.",
    close: "Kapat",
  },
  // Stats
  stats: {
    dmsSent: "Gönderilen DM'ler",
    followersGained: "Kazanılan Takipçiler",
    commentsSent: "Gönderilen Yorumlar",
    countries: "Ülkeler",
  },

  // Pricing
  pricing: {
    headingTitle: "İhtiyacınıza uygun",
    headingHighlight: "planı seçin",
    headingDescription:
      "Her içerik üretici için esnek fiyatlandırma — istediğiniz zaman değiştirin ve yıllık faturalandırmada daha fazla tasarruf edin",
    monthly: "Aylık",
    yearly: "Yıllık",
    get2MonthsFree: "2 Ay Ücretsiz Kazanın",
    freeTrial: "Ücretsiz Deneme",
    freeTrialDesc: "Zapify ile başlamak için mükemmel.",
    starter: "Starter",
    starterDesc: "Bireysel içerik üreticileri için ideal.",
    professional: "Profesyonel",
    professionalDesc: "Startup'lar ve küçük markalar için ideal.",
    subscribe: "Abone Ol",
    startFreeTrial: "30 Günlük Ücretsiz Denemeyi Başlat",
    free: "ÜCRETSİZ",
    noCreditCard: "Kredi Kartı Gerekmez",
    bestSeller: "En Çok Satan",
    perMonth: "/ay",
    save: "Tasarruf",
    unlimited: "Sınırsız",
    limited: "Sınırlı",
    email: "E-posta",
    priority: "Öncelikli",
    automations: "Otomasyonlar",
    dms: "DM'ler",
    aiReplies: "Yapay Zeka Yanıtları",
    askToFollow: "Takip İsteği",
    emailCollection: "E-posta Toplama",
    igProfile: "IG Profili",
    teamAccess: "Ekip Erişimi",
    support: "Destek",
    platformBranding: "Platform Markalaması",
    // Category headers
    automationPower: "Otomasyon Gücü",
    aiCapabilities: "AI Yetenekleri",
    leadGeneration: "Lead Oluşturma",
    analyticsTeam: "Analizler & Ekip",
    supportPlatform: "Destek & Platform",
    soonBadge: "Yakında",
    // AUTOMATION POWER features
    activeAutomations: "Aktif otomasyonlar",
    instagramAccounts: "Instagram hesapları",
    customTriggerWords: "Özel tetikleyici kelimeler",
    instantDMReplies: "Anlık DM yanıtları",
    commentToDMAutomation: "Yorum-DM otomasyonu",
    storyReplyAutomation: "Hikaye yanıt otomasyonu",
    welcomeMessageAutomation: "Karşılama mesajı otomasyonu",
    smartGreetingMessage: "Akıllı karşılama mesajı",
    unlimitedPostsStories: "Sınırsız gönderi ve hikaye otomasyonu",
    flexiblePostTargeting: "Esnek gönderi hedefleme (sonraki, herhangi, çoklu)",
    linkInDMCTAButtons: "DM içi bağlantılar ve CTA butonları",
    followGatedDMsLinks: "Takip-korumalı DM'ler ve bağlantılar",
    instagramSafetyLimits: "Instagram güvenlik limitleri",
    customFlowBuilder: "Özel akış oluşturucu",
    // AI CAPABILITIES features
    aiCommentReplies: "AI yorum yanıtları / ay",
    aiPoweredInstantReplies: "AI destekli anlık yanıtlar",
    aiTrainedOnBrand: "Markanız üzerinde eğitilmiş AI",
    // LEAD GENERATION features
    storedContacts: "Depolanan kişiler",
    emailCaptureInsideDMs: "DM içinde email yakalama",
    // ANALYTICS & TEAM features
    instagramInsights: "Instagram içgörüleri",
    monthlyPerformanceReports: "Aylık performans raporları",
    teamMembers: "Ekip üyeleri",
    // SUPPORT & PLATFORM features
    customerSupport: "Müşteri desteği",
    languageSupport: "Dil desteği",
    offerTitle: "Sınırlı Süreli Teklif",
    offerDesc: "Bugün kaydolun ve alın",
    offerBadge: "BUGÜN %10 İNDİRİM",
    limitedSpots: "Sınırlı Kontenjan",
    offerEndsIn: "Teklif sona eriyor",
    days: "Gün",
    hours: "Saat",
    minutes: "Dakika",
    seconds: "Saniye",
    claimed: "talep edildi",
    secureCheckout: "Güvenli ödeme",
    noCreditCardRequired: "Kredi kartı gerekmez",
    copied: "KOPYALANDI!",
    comparePlansEyebrow: "Boş laf yok",
    comparePlansTitle: "Bir sonraki Hikayenden önce karar ver",
    comparePlansSubtitle:
      "Otomasyonlar, DM'ler, yapay zeka, ekip - hepsi tek tabloda; \"sınırsız\"ın ne anlama geldiğini tahmin etmeyin. Bir kez oku, bir kez seç, bitti.",
    compareFeatureColumn: "Özellik",
    plansCtaBadgeLead: "Akıllı başla.",
    plansCtaBadgeEmphasis: "Daha fazla üret.",
    plansCtaTitleLead: "Seni tutmak için değil.",
    plansCtaTitleGradient: "Seni özgürleştirmek için.",
    plansCtaSubtitle:
      "Çoğu araç bağımlılık öğretir. Biz tersi: tüketen şeyi otomatikleştir, önemli yerde kal, gerçek sohbetleri ivmeye çevir.",
    plansCtaSubtitleParagraph2:
      "Her şey öyle sessiz işler ki neredeyse bizi düşünmezsin—o an işimizi doğru yaptık deriz.",
    plansCtaBullet1: "Kredi kartı gerekmez",
    plansCtaBullet3: "İstediğiniz zaman iptal, uzun süreli taahhüt yok",
    plansCtaTrust: "Dünya çapında 5.000+ içerik üreticisi bize güveniyor",
    signupMixEyebrow: "Kayıt özeti",
    signupMixCountLabel: "bu örneklemdeki kayıt",
    signupMixLeadTitle: "Nasıl başladılar",
    signupMixLeadSubtitle:
      "Çoğu ücretsiz denemeyle başlar. Kalanı Starter ile doğrudan Professional arasında paylaşılır.",
    signupMixLabelFreeTrial: "Ücretsiz deneme",
    signupMixLabelStarter: "Starter",
    signupMixLabelProfessional: "Professional",
  },

  // CTA
  cta: {
    readyToTransform: "Instagram'ınızı Dönüştürmeye Hazır mısınız?",
    joinThousands:
      "Takipçi kazanmak, etkileşimi artırmak ve zaman kazanmak için Zapify kullanan binlerce içerik üretici ve markaya katılın.",
    startForFree: "Ücretsiz Başlayın",
  },

  // Sticky
  sticky: {
    instantlyDm:
      "Instagram'ınıza yorum yapan herkese anında DM gönderin",
    limitedOffer: "Sınırlı Süreli Teklif - %10 İNDİRİM",
    endsIn: "Sona eriyor",
    getStartedFree: "Ücretsiz Başlayın",
    start: "Başla",
  },

  // Contact Page
  contactPage: {
    heading: "Destek ile İletişim",
    subtitle:
      "Büyümenize yardımcı olmak için buradayız. Sorularınız veya destek için bize ulaşın.",
    connectWithUs: "Bize Ulaşın",
    connectDescription: "Tercih ettiğiniz iletişim yolunu seçin",
    emailUs: "E-posta gönderin",
    emailResponse: "24 saat içinde yanıt vereceğiz",
    support: "Destek",
    getInstantHelp: "Anında yardım alın",
    scheduleMeet: "Toplantı Planla",
    followUs: "Bizi Takip Edin",
    stayUpdated: "En son haberlerden haberdar olun",
    responseTime: "24 saat içinde yanıt",
  },

  // Contact Form
  contactForm: {
    heading: "Bize mesaj gönderin",
    description: "Aşağıdaki formu doldurun, size geri dönüş yapalım",
    fullName: "Ad soyad",
    fullNamePlaceholder: "Adınızı ve soyadınızı girin",
    emailAddress: "E-posta adresi",
    emailPlaceholder: "E-posta adresinizi girin",
    subject: "Konu",
    subjectPlaceholder: "Ne hakkında?",
    message: "Mesaj",
    messagePlaceholder: "Talebiniz hakkında daha fazla bilgi verin...",
    sending: "Gönderiliyor...",
    sendMessage: "Mesaj gönder",
    successMessage: "Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız.",
    errorMessage: "Bir hata oluştu. Lütfen tekrar deneyin.",
  },

  // Blog
  blog: {
    insightsStrategy: "İçgörüler ve strateji",
    masterTheArt: "Instagram büyümesinde",
    instagramGrowth: "ustalaşın",
    blogSubtitle: "Yorumlarınızı müşteriye dönüştürmek için uzman rehberlerini, otomasyon sırlarını ve kanıtlanmış stratejileri keşfedin.",
    searchPlaceholder: "Strateji, rehber ara...",
    followForUpdates: "Güncellemeler için takip edin",
    latestStories: "Son yazılar",
    minRead: "dk okuma",
    readStory: "Yazıyı oku",
    featuredStory: "Öne çıkan yazı",
    freshDrop: "Yeni yayınlanan",
    readArticle: "Makaleyi oku",
    noArticlesFound: "Makale bulunamadı",
    noArticlesDescription: "Aramanızla eşleşen bir makale bulamadık. Filtrelerinizi değiştirmeyi deneyin veya daha sonra tekrar kontrol edin.",
    clearSearch: "Aramayı temizle",
  },

  // Referral
  referral: {
    heading: "Tavsiye programımıza",
    headingHighlight: "katılın",
    description: "Arkadaşlarınıza Zapify'ı önerin ve ilk yıl boyunca ücretli abonelikte harcadıkları toplam gelirin %20'sini kazanın.",
    proSubscriber: "Zapify Pro abonesi",
    minimumDms: "en az 100 DM göndermiş olmak",
    joinProgram: "Tavsiye programına katıl",
    termsOfService: "hizmet şartları.",
    step1: "Adım 1",
    step1Title: "Tavsiye bağlantınızı alın",
    step1Desc: "Dakikalar içinde kaydolun — onay gerekmez! Pro abone olup 100'den fazla DM gönderdiyseniz, kazanmaya hemen başlayabilirsiniz.",
    referralLink: "Tavsiye bağlantısı",
    copy: "Kopyala",
    step2: "Adım 2",
    step2Title: "Paylaşın ve tanıtın",
    step2Desc: "Bağlantınızı kopyalayıp her yerde paylaşın — Instagram, TikTok, YouTube, e-posta veya DM. Ne kadar çok paylaşırsanız, o kadar çok kazanırsınız!",
    step3: "Adım 3",
    step3Title: "%20 komisyon kazanın",
    step3Desc: "Birisi bağlantınızı kullanarak ücretli bir plana geçtiğinde, ilk yıl boyunca ödemelerinin %20'sini kazanırsınız — aylık olarak ödenir!",
    quickStats: "Hızlı istatistikler",
    clicks: "Tıklamalar",
    converted: "Dönüştürülen",
    total: "Toplam",
    pending: "Beklemede",
    faqHeading: "Tavsiye programı",
    faqSubheading: "Tavsiye programımız hakkında en çok sorulan sorular",
    faq1Q: "Zapify tavsiye programı nedir?",
    faq1A: "Zapify tavsiye programı, platformumuza yeni kullanıcılar yönlendirerek komisyon kazanmanızı sağlar. Birisi benzersiz tavsiye bağlantınızı kullanarak ücretli bir plana abone olduğunda, ilk yıl boyunca abonelik ücretlerinin %20'sini kazanırsınız.",
    faq2Q: "Tavsiye programına kimler katılabilir?",
    faq2A: "Katılmak için Zapify Pro abonesi olmanız ve otomasyon araçlarımızı kullanarak en az 100 DM göndermiş olmanız gerekir. Bu, iş ortaklarımızın platformu gerçekten tavsiye edebilecek aktif kullanıcılar olmasını sağlar.",
    faq3Q: "Nasıl ve ne zaman ödeme alırım?",
    faq3A: "Komisyonlar, kazançlarınız 50 $ minimum ödeme eşiğine ulaştığında PayPal aracılığıyla aylık olarak ödenir. Ödemeler, kazanıldıkları ayın bitiminden yaklaşık 30 gün sonra işlenir.",
    faq4Q: "Kazanabileceğim miktarın bir sınırı var mı?",
    faq4A: "Hayır! Kazançlarınızda herhangi bir üst sınır yoktur. Ne kadar başarılı tavsiye yaparsanız, o kadar çok kazanırsınız.",
  },

  // Tools Page
  toolsPage: {
    heading: "Ücretsiz Instagram",
    headingHighlight: "Araçları",
    description:
      "Hesaplayıcılar, oluşturucular, biçimlendirme araçları ve daha fazlası — hepsi ücretsiz, kayıt gerekmez. Daha akıllı büyümek isteyen içerik üreticiler için.",
    searchPlaceholder: "Araç ara...",
    all: "Tümü",
    noToolsFound: "Aramanızla eşleşen araç bulunamadı.",
    free: "Ücretsiz",
    comingSoon: "Yakında",
    relatedTools: "İlgili Araçlar",
    relatedToolsDesc: "Instagram'ınızı büyütmek için daha fazla ücretsiz araç",
    viewAllTools: "Tüm ücretsiz araçları gör",
    frequentlyAsked: "Sıkça Sorulan",
    questionsHighlight: "Sorular",
    faqDescription: "Bu araç hakkında bilmeniz gereken her şey:",
  },

  // Use Case
  useCase: {
    heading: "Zapify ile neleri",
    headingHighlight: "otomatikleştirebilirsiniz?",
    description: "Satış artırmadan e-posta toplamaya kadar — içerik üreticilerinin ve markaların Instagram DM'lerini otomatikleştirmek ve otopilotta büyümek için Zapify'ı nasıl kullandığını görün.",
    startForFree: "Ücretsiz başlayın",
    learnMore: "Daha fazla bilgi",
    bottomCtaHeading: "Instagram DM'lerinizi otomatikleştirmeye hazır mısınız?",
    bottomCtaDesc: "Konuşmaları otomatik olarak satışa dönüştürmek için Zapify kullanan binlerce içerik üreticiye katılın.",
    freeToStart: "Başlamak ücretsiz · Kolay kurulum",
  },

  footer: {
    description:
      "Dünya genelinde 5.000'den fazla içerik üreticinin güvendiği #1 Instagram DM otomasyon aracı.",
    product: "Ürün",
    company: "Şirket",
    compare: "Karşılaştır",
    howItWorks: "Nasıl çalışır",
    termsOfService: "Hizmet Şartları",
    privacyPolicy: "Gizlilik Politikası",
    refundPolicy: "İade Politikası",
    contactUs: "Bize Ulaşın",
    referralProgram: "Tavsiye Programı",
    copyright: "Tüm hakları saklıdır.",
    builtWith: "İçerik üreticiler için \u2764\uFE0F ile yapılmıştır",
    useCasesHeading: "Kullanım Alanları",
    allUseCases: "Tüm Kullanım Alanları",
    sendLinksInDms: "DM'de Link Gönder",
    autoRespondComments: "Otomatik Yorum Yanıtlama",
    collectEmails: "E-posta Toplama",
    storyReplies: "Story Yanıtları",
  },

  // Auth
  auth: {
    welcomeToZapify: "Zapify'a hoş geldiniz",
    setItUpOnce: "Bir kez kurun. Gerisini yapay zekaya bırakın.",
    recommended: "Önerilen",
    continueWithInstagram: "Instagram ile devam et",
    continueWithGoogle: "Google ile devam et",
    redirecting: "Yönlendiriliyor...",
    orContinueWithEmail: "veya e-posta ile devam et",
    emailAddress: "E-posta adresi",
    emailRequired: "E-posta gereklidir",
    validEmail: "Lütfen geçerli bir e-posta girin",
    sendingCode: "Kod gönderiliyor...",
    startFree: "Ücretsiz başla",
    enterVerificationCode: "Doğrulama kodunu girin",
    weSentCode: "6 haneli bir kod gönderdik:",
    otpRequired: "Doğrulama kodu gereklidir",
    otpDigits: "Doğrulama kodu 6 haneli olmalıdır",
    verifying: "Doğrulanıyor...",
    verifyAndContinue: "Doğrula ve devam et",
    useDifferentEmail: "Farklı e-posta kullan",
    agreeToTerms: "Devam ederek şunları kabul etmiş olursunuz:",
    termsOfService: "Hizmet Şartları",
    and: "ve",
    privacyPolicy: "Gizlilik Politikası",
    haveDiscountCode: "İndirim kodunuz var mı?",
    discountCode: "İndirim kodu",
    enterCode: "Kodu girin",
    apply: "Uygula",
    applied: "Uygulandı",
    congratsDiscount: "Tebrikler! %20 ek indirim kazandınız.",
    invalidCode: "Geçersiz indirim kodu",
    redirectingToDashboard: "Panele yönlendiriliyor...",
    referralBannerText: "Tebrikler! %20 ek indirim kazandınız.",
    extendedTrialBannerText: "Tebrikler! {days} günlük ücretsiz deneme süresinin kilidini açtınız.",
  },

  // Comparison
  comparison: {
    updatedDate: "Mart 2026 güncellendi",
    startFreeNoCreditCard: "Ücretsiz başlayın — Kredi kartı gerekmez",
    seeFullComparison: "Tam karşılaştırmayı görün",
    quickAnswer: "Hızlı yanıt",
    featureComparison: "Özellik bazında karşılaştırma",
    samePriceTitle: "Aynı fiyat, ama gerçekte ne alıyorsunuz?",
    aiVsKeywords: "Yapay zeka niyet tanıma ile temel anahtar kelime şablonları karşılaştırması",
    userComments: "Kullanıcıların yorumlara gerçekte yazdıkları:",
    bottomCtaHeading: "Daha akıllı alternatifi denemeye hazır mısınız?",
    bottomCtaDesc: "Yapay zeka destekli Instagram otomasyonu için Zapify'a geçen binlerce içerik üreticiye katılın.",
    getStarted: "Ücretsiz başlayın",
    freeToStart: "Başlamak ücretsiz · Kredi kartı gerekmez",
    feature: "Özellik",
    category: "Kategori",
    pricingTiers: "Fiyat kademeleri",
    faq: "Sıkça sorulan sorular",
  },

  // Legal
  legal: {
    lastUpdated: "Son güncelleme",
    haveQuestions: "Sorularınız mı var?",
    contactEmail: "Bize şu adresten ulaşabilirsiniz:",
    returnToWebsite: "Siteye dön",
    termsOfService: "Hizmet Şartları",
    privacyPolicy: "Gizlilik Politikası",
    refundPolicy: "İade Politikası",
    dataDeletion: "Veri silme politikası",
  },

  // Use Case Layout
  useCaseLayout: {
    startForFree: "Ücretsiz başlayın",
    freeToStart: "Başlamak ücretsiz · Kolay kurulum",
    frequentlyAsked: "Sıkça sorulan",
    questionsHighlight: "sorular",
    readyToAutomate: "Instagram DM'lerinizi otomatikleştirmeye hazır mısınız?",
    readyToAutomateDesc: "Konuşmaları otomatik olarak satışa dönüştürmek için Zapify kullanan binlerce içerik üreticiye katılın.",
    trigger: "Tetikleyici:",
    response: "Yanıt:",
    exploreMore: "Daha fazlasını keşfet",
  },
};

export default tr;
